const containerPreviewCompact = "@container previewContainer (max-width: 259px)";
const containerPreviewRegular = "@container previewContainer (min-width: 260px)";

export { containerPreviewCompact, containerPreviewRegular };
//# sourceMappingURL=cssPreviewContainer.js.map
